import React, { Component } from "react";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Loading from "../Loading";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { DateUtil } from "../../utils/dateUtil";
import { APIURL } from "../../config/config";
import ThaiBaht from "thai-baht-text";
import NumberFormat from "react-number-format";
import { AlertSuccess, AlertWarning } from "../Alert/Alert";
import { NumberUtil } from "../../utils/number-util";
import DatePickerIcon from "../DatePickerIcon";
import { getDocTypeConfig } from "../../services/companysetting";
import stringUtil from "../../utils/stringUtil";
import { PDFUtil } from "../../utils/pdfUtil";
import ThaiDatePicker from "../ThaiDatePicker";
import MaskedInput from "react-maskedinput";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();

const port = Number(window.env.PORT);

class CarSalesContractSamkor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      contract_id: null,
      contract_no: "",
      write_at: "",
      // Date
      startDateContract: new Date(),
      isOpenDateContract: false,
      contract_date_thai: null,
      contract_date: null,
      // End date
      seller_name: "",
      seller_address: "",
      seller_age: "",
      seller_card_code: "",
      seller_card_out_at: "",
      seller_mobile: "",
      car_name: "",
      car_license_plate: "",
      car_num_engines: "",
      car_number: "",
      car_year_name: "",
      car_color_name: "",
      car_miles: "",
      buyer_name: "",
      buyer_age: "",
      buyer_address: "",
      buyer_mobile: "",
      card_type: "บัตรประชาชน",
      card_code: "",
      card_out_at: "",
      real_sell_price: 0,
      cash_pledge: 0,
      // Date
      startPaidDueDate: new Date(),
      isOpenPaidDueDate: false,
      paid_due_date_thai: null,
      paid_due_date: null,
      // End date
      isExist: false,
      car_id: "",
      customer_id: "",
      car_sell_id: "",
      province_name: "",
      note: "",
      is_vat: 0,
      vat: 0,
      vat_amount: 0,
      total_amount: 0,
      company_setting: null,
      is_cal_vat: 0,
      carBase64Img: "",
      // Extra fields for transfer date
      startTranferDueDate: new Date(),
      isOpenTranferDueDate: false,
      tranfer_due_date_thai: null,
      tranfer_due_date: null,
      tranfer_by: "",
      contract_no_config: "",
      car_brand_name: "",
      car_type_name: "",
      car_structure_name: "",
      startSendCarDate: new Date(),
      isOpenSendCarDate: false,
      send_car_date_thai: null,
      send_car_date: null,
      send_car_time: "",

    };

    // Bind methods
    this.handleDateContract = this.handleDateContract.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCarSellById = this.loadCarSellById.bind(this);
    this.loadCarContract = this.loadCarContract.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.calOutstanding = this.calOutstanding.bind(this);
    this.handlePaidDueDate = this.handlePaidDueDate.bind(this);
    this.saveCarContract = this.saveCarContract.bind(this);
    this.printCarContract = this.printCarContract.bind(this);
    this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
    this.handleTranferDueDate = this.handleTranferDueDate.bind(this);
    this.onTranferByChanged = this.onTranferByChanged.bind(this);
    this.loadDataCarSellPay = this.loadDataCarSellPay.bind(this);
    this.handleSendCarDate = this.handleSendCarDate.bind(this);
  }

  // ... rest of the code will continue in next changes
  async componentDidMount() {
    this.mounted = true;
    const queryString = require("query-string");
    let car_sell = queryString.parse(this.props.location.search);
    let car_sell_id = car_sell.car_sell_id;

    await this.loadCompanySetting();
    await this.loadCarContract(car_sell_id);
    await this.loadCarSellById(car_sell_id);
    await this.loadCompanyLogoBase64();
  }

  async loadCompanyLogoBase64() {
    let uri = APIURL + "/company_setting/logoimage/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ carBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCompanySetting() {
    await axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      if (company_setting !== null) {
        const is_vat = company_setting.is_vat;
        const contract_no_config = company_setting.contract_no_config;
        const include_vat = is_vat === 1 ? 1 : 0;

        this.setState({
          company_setting: company_setting,
          contract_no_config: contract_no_config,
          is_vat: is_vat,
          include_vat: include_vat,
        });
      }
    });
  }

  handleTranferDueDate(date) {
    let tranfer_due_date = moment(date).format("YYYY-MM-DD");
    let tranfer_due_date_thai = DateUtil.convertLongDateThai(tranfer_due_date);

    this.setState({
      startTranferDueDate: date,
      isOpenTranferDueDate: false,
      tranfer_due_date: tranfer_due_date,
      tranfer_due_date_thai: tranfer_due_date_thai,
    });
  }

  onTranferByChanged(e) {
    let tranfer_by = e.currentTarget.value;
    this.setState({
      tranfer_by: tranfer_by,
    });
  }

  async loadCarSellById(car_sell_id) {
    if (this.state.contract_id !== null) {
      // มีรายการสัญญาแล้ว ไม่ต้องโหลดข้อมูล
      return;
    }
    const { is_vat, vat } = this.state;
    //โหลดข้อมูลตั้งต้น ตอนยังไม่กดบันทึกสัญญา
    await axios
      .get(APIURL + "/car_sell/" + car_sell_id)
      .then((res) => {
        if (this.mounted) {
          let car_sell = res.data[0];
          // let car_sell_date = car_sell.car_sell_date
          // let date = new Date(car_sell_date)
          let car_name = car_sell.car_name;
          let car_brand_name = car_sell.car_brand_name;
          let car_type_name = car_sell.car_type_name;
          let car_structure_name = car_sell.car_structure_name;
          let car_miles = car_sell.car_miles;
          let car_license_plate =
            car_sell.car_license_plate_new !== "" &&
            car_sell.car_license_plate_new !== car_sell.car_license_plate_old
              ? car_sell.car_license_plate_new
              : car_sell.car_license_plate_old;
          let car_num_engines = car_sell.car_num_engines; // เลขเครื่องยนต์
          car_num_engines = car_num_engines.toUpperCase();
          let car_number = car_sell.car_number; // เลขตัวรถ
          car_number = car_number.toUpperCase();
          let car_year_name = car_sell.car_year_name; // ปี
          let car_color_name = car_sell.car_color_name; // สี

          let customer_lastname = car_sell.customer_lastname;
          let buyer_name = car_sell.customer_name + " " + customer_lastname; // ผู้ซื้อ
          let buyer_age = car_sell.customer_age; // ผู้ซื้อ
          let buyer_address = car_sell.customer_address; // ผู้ซื้อ
          let buyer_mobile = car_sell.customer_mobile; // ผู้ซื้อ
          let card_code = car_sell.customer_card_id; // ผู้ซื้อ

          let note = car_sell.note; // หมายเหตุ

          let real_sell_price = car_sell.real_sell_price;
          let car_id = car_sell.car_id;
          let customer_id = car_sell.customer_id;

          let vat_amount = 0;
          let is_cal_vat = 0;

          // console.log(car_sell.car_sell_type_id , typeof car_sell.car_sell_type_id)

          if (port === 9038 || port === 9039) {
            // 1.สด 2.ผ่อน
            if (car_sell.car_sell_type_id === 1) {
              vat_amount = 0;
              is_cal_vat = 1;
            } else {
              if (is_vat === 1) {
                let vat_amount_cal = real_sell_price * (vat / 100);
                vat_amount = parseFloat(String(vat_amount_cal)).toFixed(0);
              }
            }
          } else {
            if (is_vat === 1) {
              let vat_amount_cal = real_sell_price * (vat / 100);
              vat_amount = parseFloat(String(vat_amount_cal)).toFixed(0);
            }
          }
          //console.log('port=', port)
          //console.log('is_vat=', is_vat)
          //console.log('vat_amount=', vat_amount)
          let total_amount = Number(real_sell_price) + Number(vat_amount);

          let province_name =
            car_sell.car_license_plate_new !== "" &&
            car_sell.car_license_plate_new !== car_sell.car_license_plate_old
              ? car_sell.province_name_new
              : car_sell.province_name_old;

          let company_name = this.state.company_setting.company_name;
          let write_at = company_name;

          this.setState(
            {
              write_at,
              car_name,
              car_brand_name,
              car_type_name,
              car_structure_name,
              car_miles,
              car_license_plate,
              car_num_engines,
              car_number,
              car_year_name,
              car_color_name,
              buyer_name,
              buyer_age,
              buyer_address,
              buyer_mobile,
              card_code,
              real_sell_price,
              car_id,
              customer_id,
              province_name,
              car_sell_id,
              vat_amount,
              total_amount,
              is_cal_vat: is_cal_vat,
              note,
            },
            () => {
              this.loadDataCarSellPay(car_sell, car_id, customer_id);
            }
          );
        }
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCarContract(car_sell_id) {
    await axios
      .get(APIURL + "/contract/car_sell/" + car_sell_id)
      .then((res) => {
        let data = res.data;
        if (data.length === 1) {
          let contract = data[0];
          let contract_date = moment(contract.contract_date).format("YYYY-MM-DD");
          let contract_date_thai = DateUtil.convertLongDateThai(contract_date);

          let paid_due_date = moment(contract.paid_due_date).format("YYYY-MM-DD");
          let paid_due_date_thai = DateUtil.convertLongDateThai(paid_due_date);

          let province_name =
            contract.car_license_plate_new !== "" &&
            contract.car_license_plate_new !== contract.car_license_plate_old
              ? contract.province_name_new
              : contract.province_name_old;

          let is_cal_vat = contract.vat_amount === 0 ? 1 : 0;

          let tranfer_due_date = moment(contract.tranfer_due_date).format("YYYY-MM-DD");
          let tranfer_due_date_thai = DateUtil.convertLongDateThai(tranfer_due_date);

         //let send_car_date = moment(contract.send_car_date).format("YYYY-MM-DD");
          let send_car_date = contract.send_car_date === 'Invalid date' || contract.send_car_date === '' || contract.send_car_date === '0000-00-00'? null : moment(contract.send_car_date).format("YYYY-MM-DD");
          let send_car_date_thai = DateUtil.convertLongDateThai(send_car_date);

          this.setState({
            contract_date_thai,
            paid_due_date_thai,
            send_car_date_thai,
            seller_age: contract.seller_age,
            seller_mobile: contract.seller_mobile,
            seller_card_code: contract.seller_card_code,
            seller_card_out_at: contract.seller_card_out_at,
            contract_id: contract.contract_id,
            contract_no: contract.contract_no,
            contract_date: contract.contract_date,
            buyer_address: contract.buyer_address,
            buyer_age: contract.buyer_age,
            buyer_mobile: contract.buyer_mobile,
            buyer_name: contract.buyer_name,
            car_color_name: contract.car_color_name,
            car_type_name: contract.car_type_name,
            car_structure_name: contract.car_structure_name,
            car_brand_name: contract.car_brand_name,
            car_id: contract.car_id,
            car_license_plate: contract.car_license_plate,
            car_name: contract.car_name,
            car_num_engines: contract.car_num_engines,
            car_number: contract.car_number,
            car_sell_id: contract.car_sell_id,
            car_year_name: contract.car_year_name,
            car_miles: contract.car_miles,
            card_code: contract.card_code,
            card_out_at: contract.card_out_at,
            card_type: contract.card_type,
            cash_pledge: contract.cash_pledge,
            customer_id: contract.customer_id,
            paid_due_date: contract.paid_due_date,
            real_sell_price: contract.real_sell_price,
            vat: contract.vat,
            vat_amount: contract.vat_amount,
            total_amount: contract.total_amount,
            seller_name: contract.seller_name,
            seller_address: contract.seller_address,
            write_at: contract.write_at,
            note: contract.note,
            province_name,
            is_cal_vat,
            tranfer_due_date: contract.tranfer_due_date,
            tranfer_due_date_thai,
            tranfer_by: contract.tranfer_by,
            send_car_date: contract.send_car_date,
            send_car_time: contract.send_car_time,
          });
        }
      });
  }

  loadDataCarSellPay(car_sell, car_id, customer_id) {
    if (car_id === "" || customer_id === "") {
      return;
    }

    axios
        .get(APIURL + "/car_sell_pay/buy/" + car_id + "/" + customer_id)
        .then((res) => {
          let car_sell_pay_list = res.data;
          let sum_pay = car_sell_pay_list.reduce(
              (acc, pay) => acc + pay.car_sell_pay_count,
              0
          );

          let real_sell_price = this.state.real_sell_price;
          let outstanding = Number(real_sell_price) - sum_pay;

          this.setState({
            cash_pledge: sum_pay,
            outstanding: outstanding,
          });
        })
        .catch((error) => {
          console.log(error);
        });
  }

  saveCarContract(action) {
    let {
      contract_no,
      write_at,
      seller_name,
      car_name,
      car_license_plate,
      car_num_engines,
      car_number,
      car_year_name,
      car_color_name,
      buyer_name,
      buyer_age,
      buyer_address,
      buyer_mobile,
      card_type,
      card_code,
      card_out_at,
      real_sell_price,
      cash_pledge,
      car_id,
      customer_id,
      car_sell_id,
      note,
      tranfer_by,
      contract_no_config,
      vat,
      vat_amount,
      total_amount,
      seller_address,
      seller_age,
      seller_mobile,
      seller_card_code,
      seller_card_out_at,
      car_brand_name,
      car_type_name,
      car_structure_name,
      car_miles,
      send_car_time,
    } = this.state;

    let contract_date = this.state.contract_date === "" ? null : moment(this.state.contract_date).format("YYYY-MM-DD");
    let tranfer_due_date = this.state.tranfer_due_date === "" ? null : moment(this.state.tranfer_due_date).format("YYYY-MM-DD");
    let paid_due_date = this.state.paid_due_date === "" ? null : moment(this.state.paid_due_date).format("YYYY-MM-DD");
    let send_car_date = this.state.send_car_date === "" ? null : moment(this.state.send_car_date).format("YYYY-MM-DD");

    if (contract_no === "" && contract_no_config === "manual") {
      AlertWarning("กรุณากรอกเลขสัญญา");
      return;
    }

    if (write_at === "") {
      AlertWarning("กรุณากรอกเขียนที่");
      return;
    }

    // Validate other required fields...

    let data = {
      contract_no,
      write_at,
      contract_date,
      seller_name,
      car_name,
      car_license_plate,
      car_num_engines,
      car_number,
      car_year_name,
      car_color_name,
      buyer_name,
      buyer_age,
      buyer_address,
      buyer_mobile,
      card_type,
      card_code,
      card_out_at,
      real_sell_price,
      cash_pledge,
      paid_due_date,
      car_id,
      customer_id,
      car_sell_id,
      contract_type: "sell",
      note,
      vat,
      vat_amount,
      total_amount,
      tranfer_due_date,
      tranfer_by,
      contract_no_config,
      seller_address,
      seller_age,
      seller_mobile,
      seller_card_code,
      seller_card_out_at,
      car_brand_name,
      car_type_name,
      car_structure_name,
      car_miles,
      send_car_date,
      send_car_time,
    };

    this.setState(
      {
        isLoading: true,
      },
      () => {
        if (action === "add") {
          let url = APIURL + "/contract";
          axios
            .post(url, data)
            .then((res) => {
              if (res.status === 200) {
                let resData = res.data;
                AlertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว");
                this.setState({
                  isLoading: false,
                  contract_id: resData.contract_id,
                  contract_no: resData.contract_no,
                });
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        } else if (action === "edit") {
          let contract_id = this.state.contract_id;
          let editData = { ...data, contract_id: contract_id };
          let url = APIURL + "/contract";
          axios
            .put(url, editData)
            .then((res) => {
              if (res.data === "success") {
                AlertSuccess("แก้ไขข้อมูลเรียบร้อยแล้ว");
                this.setState({
                  isLoading: false,
                });
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        }
      }
    );
  }

  printCarContract() {
    let contract_no = this.state.contract_no;
    let write_at = this.state.write_at;
    let seller_name = this.state.seller_name;
    let car_name = this.state.car_name;
    let car_license_plate = this.state.car_license_plate;
    let province_name = this.state.province_name;
    let car_num_engines = this.state.car_num_engines !== "" ? this.state.car_num_engines : 'ไม่ระบุ';
    car_num_engines = car_num_engines.toUpperCase();
    let car_number = this.state.car_number !== "" ? this.state.car_number : 'ไม่ระบุ';
    car_number = car_number.toUpperCase();
    let car_year_name = this.state.car_year_name;
    let car_color_name = this.state.car_color_name;
    let buyer_name = this.state.buyer_name;
    let buyer_age = this.state.buyer_age;
    let buyer_address = this.state.buyer_address;
    let buyer_mobile = this.state.buyer_mobile;
    let card_type = this.state.card_type;
    let card_code = this.state.card_code;
    let card_out_at = this.state.card_out_at !== "" ? this.state.card_out_at : 'ไม่ระบุ';
    let real_sell_price = this.state.real_sell_price;
    let cash_pledge = this.state.cash_pledge;
    let car_id = this.state.car_id;
    let customer_id = this.state.customer_id;
    let car_sell_id = this.state.car_sell_id;
    let outstanding = this.state.outstanding;
    let note = this.state.note;

    let seller_age = this.state.seller_age;
    let seller_mobile = this.state.seller_mobile === null || this.state.seller_mobile === '' ? 'ไม่ระบุ' : this.state.seller_mobile;
    let seller_card_code = this.state.seller_card_code === null || this.state.seller_card_code === '' ? 'ไม่ระบุ' : this.state.seller_card_code;
    let seller_card_out_at = this.state.seller_card_out_at === null || this.state.seller_card_out_at === '' ? 'ไม่ระบุ' : this.state.seller_card_out_at;
    let seller_address = this.state.seller_address === null || this.state.seller_address === '' ? 'ไม่ระบุ' : this.state.seller_address;
    let car_brand_name = this.state.car_brand_name === null || this.state.car_brand_name === '' ? 'ไม่ระบุ' : this.state.car_brand_name;
    let car_type_name = this.state.car_type_name === null || this.state.car_type_name === '' ? 'ไม่ระบุ' : this.state.car_type_name;
    let car_structure_name = this.state.car_structure_name === null || this.state.car_structure_name === '' ? 'ไม่ระบุ' : this.state.car_structure_name;
    let car_miles = this.state.car_miles === null || this.state.car_miles === '' ? 'ไม่ระบุ' : this.state.car_miles;
    let send_car_time = this.state.send_car_time === null ? 'ไม่ระบุ' : this.state.send_car_time;

    let vat = this.state.vat === 0 ? this.state.company_setting !== null ? this.state.company_setting.vat : "7" : this.state.vat;
    let vat_amount = Number(this.state.vat_amount);
    let total_amount = this.state.total_amount;

    if (car_num_engines.length > 0) {
      car_num_engines = car_num_engines.toUpperCase();
    }

    if (car_number.length > 0) {
      car_number = car_number.toUpperCase();
    }

    let car_license = car_license_plate + " " + province_name;

    let contract_date_thai = this.state.contract_date_thai;
    let paid_due_date_thai = this.state.paid_due_date_thai;
    let tranfer_due_date_thai = this.state.tranfer_due_date_thai;
    let send_car_date_thai = this.state.send_car_date_thai === '0000-00-00' || this.state.send_car_date_thai === '-' || this.state.send_car_date_thai === null ? 'ไม่ระบุ' : this.state.send_car_date_thai;

    let row_real_sell_price = {};
    let is_real_sell_price_int = Number.isInteger(real_sell_price);
    let real_sell_price_comma = is_real_sell_price_int ? NumberUtil.addCommasZeroInt(String(real_sell_price)) : NumberUtil.addCommas(String(real_sell_price));
    row_real_sell_price = {
      columns: [
        {
          width: "30%",
          text: " เป็นจำนวนเงิน",
          style: "normal",
          marginTop: 10,
        },
        {
          width: "18%",
          style: "normalCenter",
          marginTop: 10,
          text: NumberUtil.addCommasZeroInt(String(real_sell_price_comma)),
        },
        { width: "5%", style: "normal", marginTop: 10, text: "บาท" },
        {
          width: "47%",
          style: "normal",
          marginTop: 10,
          text: "(" + ThaiBaht(real_sell_price) + ")",
        },
      ],
      columnGap: 0,
      lineHeight: 0.9,
    };

    let row_vat_amount = {};
    if (vat_amount !== 0) {
      let is_vat_amount_int = Number.isInteger(vat_amount);
      let vat_amount_comma = is_vat_amount_int
          ? NumberUtil.addCommasZeroInt(String(vat_amount))
          : NumberUtil.addCommas(String(vat_amount));
      row_vat_amount = {
        columns: [
          {
            width: "30%",
            text: " ภาษีมูลค่าเพิ่ม " + String(vat) + "%",
            style: "normal",
            marginTop: 0,
          },
          {
            width: "18%",
            style: "normalCenter",
            marginTop: 0,
            text: vat_amount_comma,
          },
          { width: "5%", style: "normal", marginTop: 0, text: "บาท" },
          {
            width: "47%",
            style: "normal",
            marginTop: 0,
            text: "(" + ThaiBaht(vat_amount) + ")",
          },
        ],
        columnGap: 0,
        lineHeight: 1,
      };
    }

    let { company_setting, carBase64Img } = this.state;

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel = company_setting.company_tel === "" ? "-" : company_setting.company_tel;

    let headerLeft;
    let headerCenter;
    headerLeft = { image: carBase64Img, width: 90, margin: [23, 0, 0, 0] };
    headerCenter =
        company_name +
        "\n" +
        company_address +
        " เลขประจำตัวผู้เสียภาษี " +
        juristic_number +
        " " +
        " " +
        " โทร. " +
        company_tel;

    let seller_name_pad = stringUtil.addSpacePaddingFill(seller_name, 66);
    let car_name_pad = stringUtil.addSpacePaddingFill(car_name, 54);
    let car_num_engines_pad = stringUtil.addSpacePaddingFill(car_num_engines, 32);
    let car_number_pad = stringUtil.addSpacePaddingFill(car_number, 32);
    let car_license_pad = stringUtil.addSpacePaddingFill(car_license, 40);
    let car_year_name_pad = stringUtil.addSpacePaddingFill(car_year_name, 12);
    let car_color_name_pad = stringUtil.addSpacePaddingFill(car_color_name, 16);
    let buyer_name_pad = stringUtil.addSpacePaddingFill(buyer_name, 54);
    let buyer_age_pad = stringUtil.addSpacePaddingRightLeft(buyer_age, 12);
    let card_type_pad = stringUtil.addSpacePaddingFill(card_type, 26);
    let card_code_pad = stringUtil.addSpacePaddingRightLeft(card_code, 30);
    let card_out_at_pad = stringUtil.addSpacePaddingRightLeft(card_out_at, 30);
    let buyer_address_pad = stringUtil.addSpacePaddingFill(buyer_address, 80);
    let buyer_mobile_pad = stringUtil.addSpacePaddingFill(buyer_mobile, 36);
    let paid_due_date_thai_pad = stringUtil.addSpacePaddingRightLeft(paid_due_date_thai, 20);
    let buyer_name_pad2 = stringUtil.addSpacePaddingFill(buyer_name, 40);
    let car_license_pad2 = stringUtil.addSpacePaddingFill(car_license, 32);
    //
    let seller_age_pad = stringUtil.addSpacePaddingFill(seller_age, 12);
    let seller_card_code_pad = stringUtil.addSpacePaddingRightLeft(seller_card_code, 30);
    let seller_card_out_at_pad = stringUtil.addSpacePaddingRightLeft(seller_card_out_at, 30);
    let seller_address_pad = stringUtil.addSpacePaddingRightLeft(seller_address, 50);
    let seller_mobile_pad = stringUtil.addSpacePaddingRightLeft(seller_mobile, 36);
    let car_brand_name_pad = stringUtil.addSpacePaddingRightLeft(car_brand_name, 16);
    let car_type_name_pad = stringUtil.addSpacePaddingRightLeft(car_type_name, 40);
    let car_structure_name_pad = stringUtil.addSpacePaddingRightLeft(car_structure_name, 26);
    let car_miles_pad = stringUtil.addSpacePaddingRightLeft(car_miles, 12);
    let send_car_date_thai_pad = stringUtil.addSpacePaddingRightLeft(send_car_date_thai, 20);
    let send_car_time_pad = stringUtil.addSpacePaddingRightLeft(send_car_time, 10);

    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [35, 25, 30, 0],
      content: [
        {
          columns: [{ width: "100%", style: "normal", text: "" }],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          table: {
            widths: ["30%", "40%", "30%"],
            body: [
              [
                headerLeft,
                {
                  text: "สัญญาซื้อขายรถยนต์",
                  style: "bodyhead",
                  colSpan: 0,
                  margin: [0, 12, 0, 0],
                },
                { text: "", style: "normal" },
              ],
              [
                { text: "", style: "normal" },
                { text: "", style: "normal" },
                { text: "", style: "normal" },
              ],
              [
                /*{
                  columns: [
                    { width: "35%", style: "normalLeft", text: "เลขที่สัญญา " },
                    {
                      width: "auto",
                      style: ["normalLeft", "bottomLine"],
                      text: contract_no,
                    },
                  ],
                  alignment: "left",
                  columnGap: 8,
                  margin: [0, 6, 0, 0],
                },*/
                {
                  columns: [
                    { width: "*", style: "normalRight", text: "เขียนที่ " },
                    {
                      width: "auto",
                      style: ["normalRight", "bottomLine"],
                      text: write_at,
                    },
                  ],
                  colSpan: 3,
                  alignment: "right",
                  columnGap: 8,
                  margin: [0, 6, 0, 0],
                },
              ],
              [
                {
                  columns: [
                    { width: "*", style: "normalRight", text: "วันที่ " },
                    {
                      width: "auto",
                      style: ["normalRight", "bottomLine"],
                      text: contract_date_thai,
                    },
                  ],
                  colSpan: 3,
                  alignment: "right",
                  columnGap: 8,
                },
              ],
              [{ text: "", style: "normalRight", colSpan: 3 }, "", ""],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 2],
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "23%", style: "normal", text: "สัญญาฉบับนี้ทำขึ้นระหว่าง" },
            {
              width: "45%",
              style: ["normal", "bottomLine"],
              text: seller_name_pad,
            },
            { width: "7%", style: "normal", text: "อายุ" },
            {
              width: "5%",
              style: ["normalLeft", "bottomLine"],
              text: seller_age_pad,
            },
            { width: "*", style: "normal", text: "ปี" },
          ],
          columnGap: 10,
          lineHeight: 0.9,
        },

        {
          columns: [
            { width: "18%", style: "normal", text: "บัตรประชาชนเลขที่" },
            {
              width: "23%",
              style: ["normalLeft", "bottomLine"],
              text: seller_card_code_pad,
            },
            { width: "25%", style: "normal", text: "ออกให้ ณ ที่ว่าการเขต/อำเภอ" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: seller_card_out_at_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },

        {
          columns: [
            { width: "15%", style: "normal", text: "อยู่บ้านเลขที่" },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: seller_address_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "12%", style: "normal", text: "โทรศัพท์" },
            {
              width: "29%",
              style: ["normalLeft", "bottomLine"],
              text: seller_mobile_pad,
            },
            { width: "*", style: "normal", text: "ซึ่งต่อไปนี้ในสัญญาเรียกว่า \"ผู้ขาย\" ฝ่ายหนึ่ง กับ" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },

        {
          columns: [
            { width: 12, style: "normal", text: " " },
            {
              width: "35%",
              style: ["normal", "bottomLine"],
              text: buyer_name_pad,
            },
            { width: "7%", style: "normal", text: "อายุ" },
            {
              width: "5%",
              style: ["normalLeft", "bottomLine"],
              text: buyer_age_pad,
            },
            { width: "3%", style: "normal", text: "ปี" },
            { width: "19%", style: "normal", text: "บัตรประชาชนเลขที่" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: card_code_pad,
            },
          ],
          columnGap: 10,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "27%", style: "normal", text: "ออกให้ ณ ที่ว่าการเขต/อำเภอ" },
            {
              width: "20%",
              style: ["normalLeft", "bottomLine"],
              text: card_out_at_pad,
            },
            { width: "10%", style: "normal", text: "โทรศัพท์" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: buyer_mobile_pad,
            },
          ],
          columnGap: 10,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 75, style: "normal", text: "อยู่บ้านเลขที่" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: buyer_address_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [{ width: "100%", text: ".", style: "normalWhite" }],
          lineHeight: 0.3,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ซึ่งต่อไปนี้ในสัญญาเรียกว่า \"ผู้ซื้อ\" ฝ่ายหนึ่ง ทั้งสองฝ่ายตกลงทำสัญญาซื้อขายกันมีข้อความดังต่อไปนี้" },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [{ width: "100%", text: ".", style: "normalWhite" }],
          lineHeight: 0.2,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "37%", style: "normal", text: "1. ผู้ขายตกลงขาย ผู้ซื้อตกลงซื้อ รถยนต์ประเภท" },
            {
              width: "27%",
              style: ["normalLeft", "bottomLine"],
              text: car_type_name_pad,
            },
            { width: "7%", style: "normal", text: "ยี่ห้อ" },
            {
              width: "10%",
              style: ["normalLeft", "bottomLine"],
              text: car_brand_name_pad,
            },
            { width: "7%", style: "normal", text: "รุ่นปี" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: car_year_name_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "11%", style: "normal", text: "ลักษณะ" },
            {
              width: "16%",
              style: ["normal", "bottomLine"],
              text: car_structure_name_pad,
            },
            { width: "8%", style: "normal", text: "เลขไมล์" },
            {
              width: "auto",
              style: ["normal", "bottomLine"],
              text: NumberUtil.addCommasZeroInt(car_miles_pad),
            },
            { width: "2%", style: "normal", text: " " },
            { width: "4%", style: "normal", text: "กม." },
            { width: "16%", style: "normal", text: "หมายเลขทะเบียน" },
            {
              width: "24%",
              style: ["normalLeft", "bottomLine"],
              text: car_license_pad2,
            },
            { width: "5%", style: "normal", text: "สี" },
            {
              width: "12%",
              style: ["normalLeft", "bottomLine"],
              text: car_color_name_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },

        {
          columns: [
            { width: "18%", style: "normal", text: "หมายเลขเครื่องยนต์" },
            {
              width: "22%",
              style: ["normalLeft", "bottomLine"],
              text: car_num_engines_pad,
            },
            { width: "15%", style: "normal", text: "หมายเลขตัวถัง" },
            {
              width: "*",
              style: ["normalLeft", "bottomLine"],
              text: car_number_pad,
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "57%", style: "normal", text: "2. ผู้ซื้อตกลงซื้อ ผู้ขายตกลงขาย รถยนต์คันดังกล่าว ตามข้อ 1. ในราคาจำนวนเงิน" },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: NumberUtil.addCommas(String(real_sell_price_comma)),
            },
            { width: "1%", style: "normal", text: "  " },
            { width: "4%", style: "normal", text: "บาท" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            {
              width: "auto",
              style: ["normal", "bottomLine"],
              text: "(" + ThaiBaht(real_sell_price) + ")",
            },
            { width: "1%", style: "normal", text: "  " },
            { width: "auto", style: "normal", text: "และผู้ซื้อได้ชำระเงินให้กับผู้ขายในวันทำสัญญานี้ เป็นจำนวนเงิน" },
            { width: "1%", style: "normal", text: "  " },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: NumberUtil.addCommas(String(cash_pledge)),
            },
            { width: "1%", style: "normal", text: "  " },
            { width: "5%", style: "normal", text: "บาท" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: "(" + ThaiBaht(cash_pledge) + ")",
            },
            { width: "1%", style: "normal", text: "  " },
            { width: "auto", style: "normal", text: "ส่วนที่เหลือคงค้างชำระเป็นจำนวนเงิน" },
            { width: "1%", style: "normal", text: "  " },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: NumberUtil.addCommas(String(outstanding)),
            },
            { width: "1%", style: "normal", text: "  " },
            { width: "5%", style: "normal", text: "บาท" },
            { width: "1%", style: "normal", text: "  " },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: "(" + ThaiBaht(outstanding) + ")",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal", text: "ผู้ซื้อจะต้องชำระให้เสร็จสิ้นภายในวันที่" },
            { width: "3%", style: "normal", text: "  " },
            {
              width: "18%",
              style: ["normalLeft", "bottomLine"],
              text: paid_due_date_thai_pad,
            },
            { width: "auto", style: "normal", text: "หรือในวันที่ได้รับโอนกรรมสิทธิ์จากผู้ขายเป็นการถูกต้องเรียบร้อยแล้ว" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "auto", style: "normal",
              text: "3. ระหว่างการขอโอนกรรมสิทธิ์รถยนต์ตามข้อ 1-2 หากผู้ขายมีเหตุขัดข้องหรือด้วยเหตุผลอื่นใดก็ตาม ซึ่งไม่สามารถโอนกรรมสิทธิ์กันได้" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "อันทำให้ผู้ซื้อได้รับความเสียหาย ผู้ขายจะต้องชดใช้คืนเงินให้กับผู้ซื้อในวงเงินพร้อมทั้งดอกเบี้ยตามที่ตกลง ตลอดทั้งต้องรับผิดชอบผลที่เสียหาย" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "ทั้งทางคดีแพ่ง และอาญาอีกด้วย" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "auto", style: "normal",
              text: "4. ผู้ซื้อได้ขอให้ผู้ขายเซ็นโอนลอยการมอบกรรมสิทธิ์ พร้อมเอกสารต่างๆ เพื่อผู้ซื้อไปดำเนินการเองในการจดทะเบียนเป็นเจ้าของ" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "auto", style: "normal",
              text: "5. ในระหว่างการครอบครองรถคันดังกล่าว ผู้ซื้อเป็นผู้รับผิดชอบผู้ขับขี่ และอุบัติเหตุต่างๆ แต่ฝ่ายเดียวเปรียบเสมือนผู้ซื้อเป็นเจ้าของรถ" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "ทุกประการ" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "auto", style: "normal",
              text: "6. ผู้ขายขอให้การยืนยันว่า รถยนต์ที่ผู้ขายได้ตกลงทำสัญญาซื้อขายไว้นี้เป็นรถที่ถูกต้องตามกฏหมาย โดยผู้ขายมีกรรมสิทธิ์ครอบครองและเป็น" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "เจ้าของที่แท้จริง และหากผู้ขายบิดพริ้วไม่ขาย หรือไม่สามารถจะขายรถยนต์คันดังกล่าวให้แก่ผู้ซื้อได้ในภายหลัง ยินดีให้ผู้ซื้อปรับเป็นค่าเสียหายเป็น" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "เงินสองเท่าของวงเงินมัดจำพร้อมทั้งคืนเงินมัดจำให้แก่ผู้ซื้อ หรือหากผู้ซื้อไม่สามารถมาชำระเงินส่วนที่เหลือตามสัญญาได้ ยินดีให้ผู้ขายริบเงินมัดจำ" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: "auto", style: "normal",
              text: "ทั้งหมดทันที ผู้ซื้อได้รับมอบรถยนต์คันดังกล่าวข้างต้นจากผู้ขายเป็นที่เรียบร้อยแล้ว เมื่อวันที่" },
            { width: "2%", style: "normal", text: "  " },
            {
              width: "18%",
              style: ["normalLeft", "bottomLine"],
              text: send_car_date_thai_pad,
            },
            { width: "auto", style: "normal", text: "เวลา" },
            { width: "2%", style: "normal", text: "  " },
            {
              width: "auto",
              style: ["normalLeft", "bottomLine"],
              text: send_car_time_pad,
            },
            { width: "2%", style: "normal", text: "  " },
            { width: "auto", style: "normal", text: "น." },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [
            { width: 12, style: "normal", text: " " },
            { width: "auto", style: "normal",
              text: "ข้อความข้างต้น ทั้งสองฝ่ายได้อ่าน และมีความเข้าใจโดยตลอด จึงได้ลงลายมือชื่อไว้เป็นหลักฐานต่อหน้าพยาน" },
          ],
          columnGap: 0,
          lineHeight: 0.9,
        },
        {
          columns: [{ width: "100%", text: ".", style: "normalWhite" }],
          lineHeight: 0.2,
        },

        {
          columns: [
            {
              width: "50%",
              style: "normalCenter",
              text: "ลงชื่อ ............................................................................ผู้ขาย",
            },
            {
              width: "50%",
              style: "normalCenter",
              text: "ลงชื่อ ............................................................................ผู้ซื้อ",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 14, 0, 0],
        },
        {
          columns: [
            { width: "10%", text: "", style: "normalCenter" },
            {
              width: "35%",
              style: "normal",
              text: " (.......................................................................) ",
            },
            { width: "15%", text: "", style: "normalCenter" },
            {
              width: "35%",
              style: "normal",
              text: " (.......................................................................) ",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 1, 0, 0],
        },

        {
          columns: [
            {
              width: "50%",
              style: "normalCenter",
              text: "ลงชื่อ ............................................................................พยาน",
            },
            {
              width: "50%",
              style: "normalCenter",
              text: "ลงชื่อ ............................................................................พยาน",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 14, 0, 0],
        },
        {
          columns: [
            { width: "10%", text: "", style: "normalCenter" },
            {
              width: "35%",
              style: "normal",
              text: " (.......................................................................) ",
            },
            { width: "15%", text: "", style: "normalCenter" },
            {
              width: "35%",
              style: "normal",
              text: " (.......................................................................) ",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 1, 0, 0],
        },
        {
          columns: [
            {
              width: "50%",
              style: "normalCenter",
              text: "ลงชื่อ ............................................................................ผู้รับรถ",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 14, 0, 0],
        },
        {
          columns: [
            { width: "10%", text: "", style: "normalCenter" },
            {
              width: "33%",
              style: "normal",
              text: " (..................................................................) ",
            },
          ],
          columnGap: 0,
          lineHeight: 0.9,
          margin: [0, 1, 0, 0],
        },

        [
          {
            columns: [
              {
                width: "100%",
                style: "normal",
                text:
                    note === "" || note === null || note === 'undefned'
                        ? "หมายเหตุ ....................................................................................................................................................................................................."
                        : "หมายเหตุ " + " " + note,
              },
            ],
            columnGap: 0,
            lineHeight: 0.9,
            margin: [0, 14, 0, 0],
          },
        ],
        [
          {
            columns: [
              {
                width: "100%",
                style: "normal",
                text:
                    note === "" || note === null || note === 'undefned'
                        ? "......................................................................................................................................................................................................................"
                        : " ",
              },
            ],
            columnGap: 0,
            lineHeight: 0.9,
            margin: [0, 3, 0, 0],
          },
        ]
      ],
      styles: {
        bodyhead: {
          fontSize: 20,
          bold: true,
          alignment: "center",
        },
        normal: {
          fontSize: 14,
        },
        normalRight: {
          fontSize: 14,
          alignment: "right",
        },
        normalLeft: {
          fontSize: 14,
          alignment: "left",
        },
        normalCenter: {
          fontSize: 14,
          alignment: "center",
        },
        textBold2: {
          fontSize: 14,
          bold: true,
        },
        bottomLine: {
          decoration: "underline",
          decorationStyle: "dotted",
        },
        normalWhite: {
          fontSize: 14,
          color: "#ffffff",
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };

    pdfMake.createPdf(docDefinition).open();
  }

  handleDateContract(date) {
    let contract_date = moment(date).format("YYYY-MM-DD");
    let contract_date_thai = DateUtil.convertLongDateThai(contract_date);

    this.setState({
      startDateContract: date,
      isOpenDateContract: false,
      contract_date: contract_date,
      contract_date_thai: contract_date_thai,
    });
  }

  handlePaidDueDate(date) {
    let paid_due_date = moment(date).format("YYYY-MM-DD");
    let paid_due_date_thai = DateUtil.convertLongDateThai(paid_due_date);

    this.setState({
      startPaidDueDate: date,
      isOpenPaidDueDate: false,
      paid_due_date: paid_due_date,
      paid_due_date_thai: paid_due_date_thai,
    });
  }

  handleSendCarDate(date){
    let send_car_date = moment(date).format("YYYY-MM-DD");
    let send_car_date_thai = DateUtil.convertLongDateThai(send_car_date);

    this.setState({
      startSendCarDate: date,
      isOpenSendCarDate: false,
      send_car_date: send_car_date,
      send_car_date_thai: send_car_date_thai,
    });
  }

  handleOnChange(e) {
    let name = e.target.name;
    let val = e.target.value;

    this.setState({
      [name]: val,
    });
  }

  calOutstanding() {
    const { is_vat, vat } = this.state;

    let real_sell_price = this.state.real_sell_price;
    let cash_pledge = this.state.cash_pledge;
    let is_cal_vat = this.state.is_cal_vat;
    let vat_amount = Number(this.state.vat_amount);

    let is_real_sell_price_int = Number.isInteger(real_sell_price);
    let to_fixed = is_real_sell_price_int ? 0 : 2;

    if (vat_amount !== 0) {
      if (is_vat === 1) {
        let vat_amount_cal = real_sell_price * (vat / 100);
        vat_amount = parseFloat(String(vat_amount_cal)).toFixed(to_fixed);
      }
    } else {
      if (is_cal_vat === 0) {
        let vat_amount_cal = Number(real_sell_price) * (vat / 100);
        vat_amount = parseFloat(String(vat_amount_cal)).toFixed(to_fixed);
      }
    }

    let total_amount = Number(real_sell_price) + Number(vat_amount);
    let outstanding = Number(total_amount) - cash_pledge;

    this.setState({
      outstanding: outstanding,
      vat_amount,
      total_amount,
    });
  }

  render() {

    //let car_name = this.state.car_name; //ชื่อรถ
    //let car_brand_name = this.state.car_brand_name;
    /*let car_model_name = this.state.car_model_name;
    let car_sub_model_name = this.state.car_sub_model_name;
    // ถ้า sub_model มีชื่อ model ซ้ำอยู่ข้างใน ให้ลบ model ออกจาก sub_model
    if (car_sub_model_name.includes(car_model_name)) {
      car_sub_model_name = car_sub_model_name.replace(car_model_name, "").trim();
    }
    let car_name2 = car_brand_name + " " + car_model_name + (car_sub_model_name ? " " + car_sub_model_name : "");*/

    return (
        <div className="row" style={{ padding: 20 }}>
          <Loading isLoading={this.state.isLoading} />

          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <strong className="text-title">สัญญาซื้อขายรถยนต์</strong>
              </div>
              <div
                  className="card-block"
                  style={{ paddingLeft: 80, paddingRight: 80, paddingTop: 10 }}
              >
                {/* -- ส่วนหัว : เขียนที่ / วันที่ -- */}
                <div className="row" style={{ lineHeight: 2.0 }}>
                  <table style={styles.table}>
                    <tbody>
                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        &nbsp;
                      </td>
                      <td style={styles.tdContentCenter}>
                        <strong style={{ fontSize: 18 }}>
                          สัญญาซื้อขายรถยนต์
                        </strong>
                      </td>
                      <td width={"30%"}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td style={styles.tdContentLeft}>
                        <div className="hidden form-inline mt-5 mb-3">
                          เลขที่สัญญา
                          <input
                              className="form-control ml-4"
                              style={styles.inputDataNum}
                              value={this.state.contract_no || ""}
                              disabled={
                                this.state.contract_no_config !== "manual"
                              }
                              placeholder={
                                this.state.contract_no_config !== "manual"
                                    ? "AUTO"
                                    : ""
                              }
                              onChange={(e) => {
                                this.setState({
                                  contract_no: e.target.value,
                                });
                              }}
                          />
                        </div>
                      </td>
                      <td>&nbsp;</td>
                      <td style={styles.tdContentRight}>
                        <div className="form-inline mt-5" style={{ justifyContent: "right" }}
                        >
                          เขียนที่
                          <input
                              className="form-control ml-3"
                              style={styles.inputDataWriteAt}
                              value={this.state.write_at}
                              onChange={(e) => {
                                this.setState({
                                  write_at: e.target.value,
                                });
                              }}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td style={styles.tdContentLeft}> &nbsp; </td>
                      <td>&nbsp;</td>
                      <td style={styles.tdContentRight}>
                        <div
                            className="mb-4 row"
                            style={{ justifyContent: "right" }}
                        >
                          วันที่
                          <input
                              readOnly={true}
                              className="form-control ml-3"
                              style={{ width: 180 }}
                              value={
                                this.state.contract_date_thai === null
                                    ? ""
                                    : this.state.contract_date_thai
                              }
                          />
                          <div style={styles.iconCalendar}>
                            <DatePicker
                                selected={this.state.startDateContract}
                                onChange={this.handleDateContract}
                                dateFormat="yyyy-MM-dd"
                                customInput={<DatePickerIcon />}
                            />
                          </div>
                          {this.state.isOpenDateContract && (
                              <DatePicker
                                  selected={this.state.startDateContract}
                                  onChange={this.handleDateContract}
                                  dateFormat="yyyy-MM-dd"
                                  inline
                              />
                          )}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline ml-5">
                          <span>
                            สัญญาฉบับนี้ทำขึ้นระหว่าง
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputSoLong}
                              name="seller_name"
                              value={this.state.seller_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            อายุ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="seller_age"
                              value={this.state.seller_age}
                              onChange={this.handleOnChange}
                          /> ปี
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                           <span>
                            บัตรประชาชนเลขที่
                          </span>
                          <MaskedInput
                              mask="1-1111-11111-11-1"
                              className="form-control ml-3 mr-3"
                              id="seller_card_code"
                              name="seller_card_code"
                              maxLength="20"
                              placeholder=""
                              value={this.state.seller_card_code}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            ออกให้ ณ ที่ว่าการเขต/อำเภอ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="seller_card_out_at"
                              value={this.state.seller_card_out_at}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                           <span>
                            อยู่บ้านเลขที่
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputData}
                              name="seller_address"
                              value={this.state.seller_address}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            โทรศัพท์
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="seller_mobile"
                              value={this.state.seller_mobile}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                           <span>
                            ซึ่งต่อไปนี้ในสัญญาเรียกว่า "ผู้ขาย" ฝ่ายหนึ่ง กับ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputData}
                              name="buyer_name"
                              value={this.state.buyer_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            อายุ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="buyer_age"
                              value={this.state.buyer_age}
                              onChange={this.handleOnChange}
                              inputMode={"numeric"}
                              maxLength={2}
                          /> ปี

                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                           <span>
                            บัตรประชาชนเลขที่
                          </span>
                          <MaskedInput
                              mask="1-1111-11111-11-1"
                              className="form-control ml-3 mr-3"
                              id="card_code"
                              name="card_code"
                              maxLength="20"
                              placeholder=""
                              value={this.state.card_code}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            ออกให้ ณ ที่ว่าการเขต/อำเภอ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="card_out_at"
                              value={this.state.card_out_at}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                           <span>
                            อยู่บ้านเลขที่
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputData}
                              name="buyer_address"
                              value={this.state.buyer_address}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            โทรศัพท์
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="buyer_mobile"
                              value={this.state.buyer_mobile}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            ซึ่งต่อไปนี้ในสัญญาเรียกว่า "ผู้ซื้อ" ฝ่ายหนึ่ง ทั้งสองฝ่ายตกลงทำสัญญาซื้อขายกันมีข้อความดังต่อไปนี้
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            1. ผู้ขายตกลงขาย ผู้ซื้อตกลงซื้อ รถยนต์ประเภท
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="car_type_name"
                              value={this.state.car_type_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            ยี่ห้อ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="car_brand_name"
                              value={this.state.car_brand_name}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            รุ่นปี
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="car_year_name"
                              value={this.state.car_year_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            ลักษณะ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="car_structure_name"
                              value={this.state.car_structure_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            เลขไมล์
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="car_miles"
                              value={this.state.car_miles}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            หมายเลขทะเบียน
                          </span>
                          <input
                              className="form-control ml-3"
                              style={styles.inputShort}
                              name="car_license_plate"
                              value={this.state.car_license_plate}
                              onChange={this.handleOnChange}
                          />
                          <input
                              className="form-control ml-1"
                              style={styles.inputShort}
                              name="province_name"
                              disabled
                              value={this.state.province_name}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            สีรถ
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="car_color_name"
                              value={this.state.car_color_name}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            หมายเลขเครื่องยนต์
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="car_num_engines"
                              value={this.state.car_num_engines}
                              onChange={this.handleOnChange}
                          />

                          <span>
                            หมายเลขตัวถัง
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputLong}
                              name="car_number"
                              value={this.state.car_number}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            2. ผู้ซื้อตกลงซื้อ ผู้ขายตกลงขาย รถยนต์คันดังกล่าว ตามข้อ 1. ในราคาจำนวนเงิน
                          </span>
                          <NumberFormat
                              className="form-control ml-3 mr-3"
                              decimalScale={2}
                              fixedDecimalScale
                              style={styles.inputMedium}
                              thousandSeparator={true}
                              prefix={""}
                              placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.real_sell_price}
                              onValueChange={(values) => {
                                const { value } = values;
                                if (value === "") {
                                  return;
                                }
                                this.setState({ real_sell_price: value }, () =>
                                    this.calOutstanding()
                                );
                              }}
                          /> บาท
                          <span className="ml-2">
                            ({ThaiBaht(this.state.real_sell_price)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            และผู้ซื้อได้ชำระเงินให้กับผู้ขายในวันทำสัญญานี้ เป็นจำนวนเงิน
                          </span>
                          <NumberFormat
                              className="form-control ml-3 mr-3"
                              decimalScale={2}
                              fixedDecimalScale
                              style={styles.inputMedium}
                              thousandSeparator={true}
                              prefix={""}
                              placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.cash_pledge}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState({ cash_pledge: value }, () =>
                                    this.calOutstanding()
                                );
                              }}
                          />
                          บาท
                          <span className="ml-2">
                            ({ThaiBaht(this.state.cash_pledge)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            ส่วนที่เหลือคงค้างชำระเป็นจำนวนเงิน
                          </span>
                          <NumberFormat
                              className="form-control ml-3 mr-3"
                              decimalScale={2}
                              fixedDecimalScale
                              style={styles.inputMedium}
                              thousandSeparator={true}
                              prefix={""}
                              placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.outstanding}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState({ outstanding: value }, () =>
                                    this.calOutstanding()
                                );
                              }}
                          />
                          บาท
                          <span className="ml-2">
                            ({ThaiBaht(this.state.outstanding)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2">
                          <span>
                            ผู้ซื้อจะต้องชำระให้เสร็จสิ้นภายในวันที่
                          </span>
                          <input
                              readOnly={true}
                              className="form-control ml-3"
                              name="paid_due_date_thai"
                              style={{ width: 180 }}
                              value={
                                this.state.paid_due_date_thai === null
                                    ? ""
                                    : this.state.paid_due_date_thai
                              }
                          />
                          <div style={styles.iconCalendar}>
                            <DatePicker
                                selected={this.state.startPaidDueDate}
                                onChange={this.handlePaidDueDate}
                                dateFormat="yyyy-MM-dd"
                                customInput={<DatePickerIcon />}
                            />
                          </div>
                          <span className="ml-3">
                            หรือในวันที่ได้รับโอนกรรมสิทธิ์จากผู้ขายเป็นการถูกต้องเรียบร้อยแล้ว
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            3. ระหว่างการขอโอนกรรมสิทธิ์รถยนต์ตามข้อ 1-2 หากผู้ขายมีเหตุขัดข้องหรือด้วยเหตุผลอื่นใดก็ตาม ซึ่งไม่สามารถโอน
                            กรรมสิทธิ์กันได้ อันทำให้ผู้ซื้อได้รับความเสียหาย
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span>
                            ผู้ขายจะต้องชดใช้คืนเงินให้กับผู้ซื้อในวงเงินพร้อมทั้งดอกเบี้ยตามที่ตกลง
                            ตลอดทั้งต้องรับผิดชอบผลที่เสียหายทั้งทางคดีแพ่ง และอาญาอีกด้วย
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            4. ผู้ซื้อได้ขอให้ผู้ขายเซ็นโอนลอยการมอบกรรมสิทธิ์ พร้อมเอกสารต่างๆ เพื่อผู้ซื้อไปดำเนินการเองในการจดทะเบียนเป็นเจ้าของ
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            5. ในระหว่างการครอบครองรถคันดังกล่าว ผู้ซื้อเป็นผู้รับผิดชอบผู้ขับขี่ และอุบัติเหตุต่างๆ แต่ฝ่ายเดียวเปรียบเสมือนผู้ซื้อเป็นเจ้าของรถทุกประการ
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            6. ผู้ขายขอให้การยืนยันว่า รถยนต์ที่ผู้ขายได้ตกลงทำสัญญาซื้อขายไว้นี้เป็นรถที่ถูกต้องตามกฏหมาย โดยผู้ขายมีกรรมสิทธิ์ครอบครอง และเป็นเจ้าของที่แท้จริง
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline">
                          <span>
                            และหากผู้ขายบิดพริ้วไม่ขาย หรือไม่สามารถจะขายรถยนต์คันดังกล่าวให้แก่ผู้ซื้อได้ในภายหลัง ยินดีให้ผู้ซื้อปรับเป็นค่าเสียหายเป็นเงินสองเท่าของวงเงินมัดจำ
                            พร้อมทั้งคืนเงินมัดจำให้แก่ผู้ซื้อ หรือหากผู้ซื้อไม่สามารถมาชำระเงินส่วนที่เหลือตามสัญญาได้ ยินดีให้ผู้ขายริบเงินมัดจำทั้งหมดทันที
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5 ">
                          <span>
                            ผู้ซื้อได้รับมอบรถยนต์คันดังกล่าวข้างต้นจากผู้ขายเป็นที่เรียบร้อยแล้ว เมื่อวันที่
                          </span>
                          <input
                              readOnly={true}
                              className="form-control ml-3"
                              style={{ width: 180 }}
                              value={
                                this.state.send_car_date_thai === null
                                    ? ""
                                    : this.state.send_car_date_thai
                              }
                          />
                          <div>
                            <DatePicker
                                selected={this.state.startSendCarDate}
                                onChange={this.handleSendCarDate}
                                dateFormat="yyyy-MM-dd"
                                customInput={<DatePickerIcon />}
                            />
                          </div>
                          <span className="ml-3">
                            เวลา
                          </span>
                          <input
                              className="form-control ml-3 mr-3"
                              style={styles.inputShort}
                              name="send_car_time"
                              value={this.state.send_car_time}
                              onChange={this.handleOnChange}
                          /> น.
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            ข้อความข้างต้น ทั้งสองฝ่ายได้อ่าน และมีความเข้าใจโดยตลอด จึงได้ลงลายมือชื่อไว้เป็นหลักฐานต่อหน้าพยาน
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-4">
                          <span >
                            หมายเหตุ
                          </span>
                          <input
                              className="form-control ml-3"
                              style={{ width: "80%", borderRadius: 5 }}
                              name="note"
                              value={this.state.note}
                              onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-12 text-right">
                  <div className="card-block">
                    {this.state.contract_id === null ? (
                        <button
                            type="button"
                            className="btn btn-success btn-md mr-2"
                            style={{ width: 120 }}
                            onClick={() => this.saveCarContract("add")}
                        >
                          <i className="icon-check" />
                          &nbsp;บันทึก
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-warning btn-md mr-2"
                            style={{ width: 120 }}
                            onClick={() => this.saveCarContract("edit")}
                        >
                          <i className="icon-pencil" />
                          &nbsp;แก้ไข
                        </button>
                    )}

                    {this.state.contract_id === null ? null : (
                        <button
                            type="button"
                            className="btn btn-primary btn-md mr-2"
                            style={{ width: 120 }}
                            onClick={() => {
                              this.printCarContract();
                            }}
                        >
                          <i className="icon-printer" /> พิมพ์
                        </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const styles = {
  table: {
    width: "100%",
    maxWidth: "100%",
  },
  tdContentCenter: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  tdContentRight: {
    textAlign: "right",
    verticalAlign: "middle",
    justifyContent: "right",
  },
  tdContentLeft: {
    textAlign: "left",
    verticalAlign: "middle",
  },
  tableTh: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
  },
  tableTdLeft: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "top",
  },
  tableTdCenter: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "left",
    verticalAlign: "middle",
    paddingLeft: "70px",
  },
  tableTdRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
  },
  tablePd: {
    paddingLeft: "50px",
    paddingRight: "50px",
    lineHeight: "2.2",
  },
  amountsText: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  amountsTextNoBorder: {
    maxWidth: "100%",
    textAlign: "center",
    verticalAlign: "middle",
  },
  amountsRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
    fontWeight: "bold",
  },
  buttonHeight: {
    height: 32,
  },
  inputData: {
    borderRadius: "5px",
    width: "450px",
  },
  inputDataNum: {
    borderRadius: "5px",
    width: "120px",
  },
  inputDataWriteAt: {
    borderRadius: "5px",
    width: "220px",
  },
  inputShort: {
    borderRadius: "5px",
    width: "120px",
  },
  inputMedium: {
    borderRadius: "5px",
    width: "190px",
  },
  inputLong: {
    borderRadius: "5px",
    width: "270px",
  },
  inputSoLong: {
    borderRadius: "5px",
    width: "525px",
  },
  toUpper: {
    textTransform: "uppercase",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CarSalesContractSamkor);
